module.exports = __webpack_public_path__ + "static/media/eth2.1d4f5347.jpg";